var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.dialogVisible)?_c('div',{ref:"Dialog",staticClass:"Dialog"},[_c('div',{staticClass:"bg",on:{"click":_vm.maskClick}}),_c('div',{staticClass:"content",style:(`width: ${_vm.width}px;`)},[_c('div',{staticClass:"title"},[_vm._v("\n        "+_vm._s(_vm.title)+"\n      ")]),_vm._t("default")],2)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }